
import FETCHING from '../../library/fetching'
import UMUM from '../../library/umum'
import DATAMASTER from '../../library/dataMaster'

export default {
  name: 'RealisasiKeuangan',
  data() {
    return {
      sidapem: null,
      form: {
        // not used for realisasi-add: data_pembangunan is master
      },
      editForm: {
        id: '',
        uraian: '',
        realisasi_fisik: null,
        realisasi_keuangan: 0,
        keterangan: ''
      },

      jml_pagu: 0,
      jml_nilaikontrak: 0,
      jml_realisasifisik: 0,
      jml_realisasikeuangan: 0,
      jml_realisasipersen: 0,

      filterku: {
        program_kode: '',
        tahun: '',
        unit_kerja: '',
        instansi: '',
      },

      list_data: [],

      page_first: 1,
      page_last: 0,
      page_limit: 8,
      cari_value: "",
      cek_load_data: true,

      mdl_edit: false,
      btn_save: false,
      FETCHING: FETCHING,
      UMUM: UMUM,
      DATAMASTER: DATAMASTER,
    }
  },
  methods: {
    getView() {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.CT_DATA_PEMBANGUNAN + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          page_limit: this.page_limit,
          instansi: this.filterku.instansi,
          unit_kerja: this.filterku.unit_kerja,
          tahun: this.filterku.tahun,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data || [];
          this.page_last = res_data.jml_data || 1;

          this.jml_pagu = typeof res_data.jml_pagu !== 'undefined' ? res_data.jml_pagu : 0;
          this.jml_nilaikontrak = typeof res_data.jml_nilaikontrak !== 'undefined' ? res_data.jml_nilaikontrak : 0;
          this.jml_realisasifisik = typeof res_data.jml_realisasifisik !== 'undefined' ? res_data.jml_realisasifisik : 0;
          this.jml_realisasikeuangan = typeof res_data.jml_realisasikeuangan !== 'undefined' ? res_data.jml_realisasikeuangan : 0;
          this.jml_realisasipersen = typeof res_data.jml_realisasipersen !== 'undefined' ? res_data.jml_realisasipersen : 0;

          this.$store.commit("hideLoading");
        }).catch(err => {
          console.error('getView error', err);
          this.$store.commit("hideLoading");
        });
    },

    openEdit(data) {
      // populate editForm with minimal fields (only 3 editable)
      this.editForm.id = data.id;
      this.editForm.uraian = data.uraian || data.nama_paket || '';
      this.editForm.realisasi_fisik = (data.realisasi_fisik === null || typeof data.realisasi_fisik === 'undefined') ? null : data.realisasi_fisik;
      this.editForm.realisasi_keuangan = data.realisasi_keuangan || 0;
      this.editForm.keterangan = data.keterangan || '';
      this.mdl_edit = true;
    },

    saveRealisasi() {
      if (!this.editForm.id) {
        this.Notify('ID data tidak ditemukan', 'negative', 'warning');
        return;
      }

      this.btn_save = true;
      fetch(this.$store.state.url.CT_DATA_PEMBANGUNAN + "updateRealisasi", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: 'kikensbatara ' + localStorage.token
        },
        body: JSON.stringify({
          id: this.editForm.id,
          realisasi_fisik: this.editForm.realisasi_fisik,
          realisasi_keuangan: Number(this.editForm.realisasi_keuangan) || 0,
          keterangan: this.editForm.keterangan
        })
      }).then(res => res.json()).then((res_json) => {
        this.btn_save = false;
        if (res_json && res_json.success) {
          this.Notify('Sukses menyimpan realisasi', 'primary', 'check_circle_outline');
          this.mdl_edit = false;
          this.getView();
        } else {
          // some backends return object even without success flag
          this.Notify('Simpan selesai', 'primary', 'check_circle_outline');
          this.mdl_edit = false;
          this.getView();
        }
      }).catch(err => {
        this.btn_save = false;
        console.error('saveRealisasi error', err);
        this.Notify('Gagal menyimpan realisasi', 'negative', 'warning');
      });
    },

    // helper / pagination
    Notify(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 800,
      })
    },

    cari_data() {
      this.page_first = 1;
      this.getView();
    },

    indexing(index) {
      var idx = ((this.page_first - 1) * this.page_limit) + index
      return idx
    },

    async onChangexInstansi() {
      // pastikan list_instansi ter-load dulu
      await DATAMASTER.getInstansiAsync("");
      await this.onChangexUnitKerjaLocal(); // pakai local yang sudah ada
    },

    async onChangexUnitKerja() {
      // tetapkan ulang unit list (jangan auto pilih kecuali hanya 1)
      const unitkerjax = await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi);
      // jangan paksa pilih, biarkan '' = Semua
      this.filterku.unit_kerja = '';
      // optional: jika cuma 1 unit tersedia, auto set (sama seperti data_pembangunan)
      if (unitkerjax && unitkerjax.length === 1) {
        this.filterku.unit_kerja = unitkerjax[0].id;
      }
      this.getView();
    },
    async onChangexUnitKerjaLocal() {
      var unitkerjax = await DATAMASTER.getUnitKerjaAsync(this.filterku.instansi)
      if (unitkerjax && unitkerjax.length > 0) {
        this.filterku.unit_kerja = unitkerjax[0].id
      } else {
        this.filterku.unit_kerja = ''
      }
      this.getView();
    },

    btn_prev() {
      if (this.page_first > 1) {
        this.page_first--
        this.getView();
      }
    },
    btn_next() {
      if (this.page_first < this.page_last) {
        this.page_first++
        this.getView();
      }
    },

  },

  async mounted() {
    let profilex = JSON.parse(localStorage.profile || '{}');
    let profile = profilex.profile || {};
    this.filterku.instansi = profile.instansi_id || '';
    this.filterku.unit_kerja = profile.unit_kerja || '';

    this.sidapem = profile.sidapem || null;

    const d = new Date();
    this.filterku.tahun = d.getFullYear();

    await DATAMASTER.getInstansiAsync('');
    DATAMASTER.getMasterPermintaan(); // jika async, tambahkan await
    DATAMASTER.getTahun();            // jika async, tambahkan await
    // sekarang load unit sesuai instansi (yang sudah terisi dari profile)
    await this.onChangexUnitKerja(); // ini akan set filterku.unit_kerja = '' dan memanggil getView()
  },
}
